<template>
	<div style="display: flex; flex-direction: column; margin-left: 25px; margin-right: 25px; margin-top: 20px;">
		<div class="miniCard"
			style="background: RGBA(236, 240, 243, 1); border-radius: 16px; display: flex; flex-direction: column;" :style="{boxShadow: !isPdfShow ? '5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF' : '', background: !isPdfShow ? ' RGBA(236, 240, 243, 1)' : '#E0E6EF'}">
			<div class="miniCardTop" @click="unflodClick" style="cursor: pointer;">
				<div style="display: flex; width: 100%; height: 34px;">
					<div style="display: flex; flex: 1;">
						<img style="width: 28px; height: 28px; margin-left: 15px; border-radius: 10px; margin-top: 3px;"
							:src="data && data.icon ? require('../../../assets/' + data.icon + '.png') : ''" alt="">
						<div style="margin-left: 10px; position: relative; margin-top: 3px;">
							<div v-html="$options.filters.reMate(data && data.titleLabel ? data.titleLabel : ' ')"></div>
							<div v-if="type != 1"
								style="position: absolute; bottom: 4px; width: 47px; height: 8px; background: linear-gradient(270deg, rgba(24,144,255,0) 0%, rgba(255,113,134,0) 0%, #FF7186 100%); border-radius: 5px; opacity: 0.3;">
							</div>
							<div v-if="type == 1"
								style="position: absolute; bottom: 4px; width: 47px; height: 8px; background: linear-gradient( 270deg, rgba(74,124,232,0) 0%, #4A7CE8 100%); border-radius: 5px; opacity: 0.3;">
							</div>
						</div>
						<QuestionMarkA v-if="data && data.index == 'ahi'" />
					</div>
					<div style="width: 34px; height: 34px; display: flex; justify-content: center; align-items: center;">
						<div :class="isUnfold ? 'unfoldImgTrue' : 'unfoldImgFalse'" style="width: 14px; height: 14px;">
						</div>
					</div>
				</div>
				<div
					style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A4ABB6; line-height: 22px; margin-left: 53px; margin-right: 49px; margin-top: 1px;">
					{{ data && data.conclusion ? data.conclusion : ' ' }}</div>
			</div>
			<div v-show="isUnfold"
				style="background: rgba(255,255,255,0.85); margin-left: 5px; margin-right: 5px; margin-bottom: 5px; border-radius: 12px; padding-top: 5px; padding-bottom: 5px;">
				<div style="background: #ECF0F3; border-radius: 8px; margin-top: 10px; margin-left: 15px; margin-right: 15px; display: flex; flex-direction: column; padding: 15px;">
					<div v-if="currentTitleIsLineFeed" style="display: flex; flex-direction: column; width: 100%;">
						<div style="display: flex;">
							<div style="width: 6px; height: 6px; background: #FF7186; border-radius: 5px; margin-right: 5px; margin-top: 8px;" :style="{background: currentDeviateDescColor}"></div>
							<div style="display: block; flex: 1; margin-right: 5px;">
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #5E6779; line-height: 20px; text-align: justify; white-space: nowrap; display: inline;">{{ currentDeviateDesc ? currentDeviateDescDate + '：' : currentDeviateDescDate }}</div>
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #5E6779; line-height: 20px; text-align: justify; display: inline;">{{ currentDeviateDesc }}</div>
							</div>
						</div>
						<div style="display: flex; align-items: center; margin-top: 5px;">
							<div style="width: 6px; height: 6px; background: rgba(53, 192, 160, 1); border-radius: 5px; margin-right: 5px;" :style="{background: currentNormalDescColor}"></div>
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #5E6779; line-height: 20px; text-align: justify;">日常表现：</div>
							<img v-if="currentNormalDescColor == 'rgba(255, 206, 11, 1)'" style="width: 14px; height: 14px; margin-right: 2px;" src="../../../assets/icon_home_new_icon_yellow_warning.png" alt="" />
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(54, 192, 160, 1); line-height: 20px; text-align: justify;"  :style="{color: currentNormalDescColor}">{{ currentNormalDesc }}</div>
						</div>
					</div>
					<div v-if="!currentTitleIsLineFeed" style="display: flex; width: 100%; align-items: center;">
						<div style="width: 6px; height: 6px; background: #FF7186; border-radius: 5px; margin-right: 5px;" :style="{background: currentDeviateDescColor}"></div>
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #5E6779; line-height: 20px; text-align: justify;">{{ currentDeviateDesc ? currentDeviateDescDate + '：' : currentDeviateDescDate }}</div>
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #5E6779; line-height: 20px; text-align: justify;">{{ currentDeviateDesc }}</div>
						<div style="width: 1px; height: 16px; background: rgba(165, 169, 188, 0.5); margin-left: 20px; margin-right: 20px;"></div>
						<div style="width: 6px; height: 6px; background: rgba(53, 192, 160, 1); border-radius: 5px; margin-right: 5px;" :style="{background: currentNormalDescColor}"></div>
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #5E6779; line-height: 20px; text-align: justify;">日常表现：</div>
						<img v-if="currentNormalDescColor == 'rgba(255, 206, 11, 1)'" style="width: 14px; height: 14px; margin-right: 2px;" src="../../../assets/icon_home_new_icon_yellow_warning.png" alt="" />
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(54, 192, 160, 1); line-height: 20px; text-align: justify;"  :style="{color: currentNormalDescColor}">{{ currentNormalDesc }}</div>
					</div>
					<div style="display: flex; height: 169px; margin-top: 10px;">
						<div style="background: #FBFCFC; border-radius: 4px; flex: 1;">
							<div style="height: 13px; margin-top: 15px; margin-left: 34px; width: 630px;">
								<div style="height: 5px; display: flex; justify-content: space-between; position: absolute; width: 630px;">
									<div style="width: 0px; height: 5px; background: #FCEEB3; border-radius: 4px; z-index: 1;" :style="{width: lineWidth1}"></div>
									<div style="width: 0px; height: 5px; background: #C0E9E0; border-radius: 4px; z-index: 1;" :style="{width: lineWidth2}"></div>
									<div style="width: 0px; height: 5px; background: #FCEEB3; border-radius: 4px; z-index: 1;" :style="{width: lineWidth3}"></div>
									<img v-if="normalBpmType == 0" style="width: 14px; height: 9px; position: absolute; z-index: 0; top: 4px; left: 0px;" :style="{left: normalBpmLeft}" src="../../../assets/icon_home_new_icon_san_jiao_1.png" alt="" />
									<img v-if="normalBpmType == 1" style="width: 14px; height: 9px; position: absolute; z-index: 0; top: 4px; left: 0px;" :style="{left: normalBpmLeft}" src="../../../assets/icon_home_new_icon_san_jiao_2.png" alt="" />
									<img v-if="normalBpmType == 2" style="width: 14px; height: 9px; position: absolute; z-index: 0; top: 4px; left: 0px;" :style="{left: normalBpmLeft}" src="../../../assets/icon_home_new_icon_san_jiao_3.png" alt="" />
								</div>
							</div>
							<div :id="echartId + 'secondChart'" style="height: 136px;"></div>
						</div>
						<div style="width: 101px; height: 169px; margin-left: 5px; display: flex; flex-direction: column; justify-content: space-between; position: relative;">
							<div style="display: flex; margin-top: 18px; margin-left: 11px; z-index: 1;">
								<div style="width: 6px; height: 6px; background: #FF7186; border-radius: 5px; margin-right: 4px; margin-top: 5px;" :style="{background: currentDeviateDescColor}"></div>
								<div style="max-width: 79px; font-weight: 400; font-size: 12px; color: #A4ABB6; line-height: 17px;">多集中在：<br/>{{ deviateBpmFocusStr }}</div>
							</div>
							<div style="display: flex; margin-left: 9px; margin-bottom: 17px; z-index: 1;">
								<img v-if="currentScopeImageType == 1" style="width: 12px; height: 9px; margin-top: 4px; margin-right: 1px;" src="../../../assets/icon_home_new_icon_fanwei_1.png" alt="" />
								<img v-if="currentScopeImageType == 2" style="width: 12px; height: 9px; margin-top: 4px; margin-right: 1px;" src="../../../assets/icon_home_new_icon_fanwei_2.png" alt="" />
								<img v-if="currentScopeImageType == 3" style="width: 12px; height: 9px; margin-top: 4px; margin-right: 1px;" src="../../../assets/icon_home_new_icon_fanwei_3.png" alt="" />
								<div>
									<div style="max-width: 79px; font-weight: 400; font-size: 12px; color: #A4ABB6; line-height: 17px;">范围：</div>
									<div style="max-width: 79px; font-weight: 400; font-size: 12px; color: #A4ABB6; line-height: 17px; min-height: 17px;">{{ currentRangeStr }}</div>
								</div>
							</div>
							<img style="width: 101px; height: 93px; position: absolute; z-index: 0;" src="../../../assets/icon_home_new_icon_bg_1.png" alt="" />
							<img style="width: 101px; height: 91px; position: absolute; bottom: 0px; z-index: 0;" src="../../../assets/icon_home_new_icon_bg_2.png" alt="" />
						</div>
					</div>
				</div>
				<div style="display: flex; height: 158px;">
					<div style="margin-left: 15px; flex: 1; position: relative;">
						<div style="height: 34px; display: flex; flex-direction: column; margin-left: 23px;">
							<div style="display: flex; flex: 1; position: relative;">
								<!-- <img style="width: 26px; height: 11px; position: absolute;" :style="{ left: ((selectIndex * (xWidth / 30))) + 'px'}" src="../../../assets/icon_home_new_icon_san_jiao_5.png" alt="" /> -->
							</div>
							<div style="display: flex; height: 14px;">
								<div v-for="(item, index) in data.xaxis || []" style="flex: 1; text-overflow: hidden; text-align: center; font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 10px; color: #A5A9BC; line-height: 14px; border-radius: 8px; width: 16px; height: 16px; display: flex; align-items: center; justify-content: center; position: relative;" :style="{background: selectIndex == index ? 'rgba(94, 103, 121, 1)' : '#FFFFFF00', color: selectIndex == index ? 'rgba(255, 255, 255, 1)' : 'rgba(165, 169, 188, 1)', opacity: (selectIndex == index || item == '今' || index % 2 == 0) ? 1 : 0 }" >
									{{item}}
									<img v-if="selectIndex == index" style="width: 26px; height: 11px; position: absolute; top: -20px;" :style="{ left: '-5px'}" src="../../../assets/icon_home_new_icon_san_jiao_5.png" alt="" />
									<div v-if="selectIndex == index" style="background: rgba(236, 240, 243, 1); position: absolute; top: 20px; bottom: -112px; left: 0px; right: 0px;"></div>
								</div>
							</div>
						</div>
						<div :id="echartId + 'FirstChartMain'" style="height: 126px; position: relative;"></div>
					</div>
					<div v-if="data && data.descLabel"
						style="position: relative; background: linear-gradient(225deg, rgba(148,192,249,0.1) 0%, rgba(173,195,243,0.1) 100%); border-radius: 8px; border: 2px rgba(74, 124, 232, 0.1) solid; margin-left: 10px; margin-right: 15px; padding: 15px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 21px; width: 302px; max-width: 302px; height: 109px; margin-top: 39px;">
						{{ data && data.descLabel ? data.descLabel : ' '  }}
						<img style="width: 30px; height: 26px; position: absolute; right: 15px; bottom: 15px;" src="../../../assets/icon_home_new_icon_dou_hao_1.png" alt="" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
  
<script>
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';
import QuestionMarkA from '../component/questionMarkA.vue'
import QuestionMarkB from '../component/questionMarkB.vue'
import getEchartsOptionLineE1 from '../component/options/echartsOptionLineE1.js'
import getEchartsOptionFloatA3 from '../component/options/echartsOptionFloatA3.js'
import getEchartsOptionFloatA31 from '../component/options/echartsOptionFloatA31.js'
import getEchartsOptionFloatA5 from '../component/options/echartsOptionFloatA5.js'

export default {
	components: {
		QuestionMarkA,
		QuestionMarkB
	},
	filters: {
		reMate(val) {
			return CustomRichText.reMateNew(portFn.function_reg_str_to_arr(val))
		},
	},
	props: {
		data: null,
		echartId: {
			type: String,
			default: null,
		},
		option: {
			type: Object,
			default: null
		},
		isPdfShow: {
			type: Boolean,
			default: false
		},
		isFold: {
			type: Boolean,
			default: false
		},
		type: {
			type: Number,
			default: 0 // 0 - 红色，1 - 黄色
		}
	},
	watch: {
		data(newVal, oldVal) {
			if (newVal) {
				// 求上部分视图的Y轴最大值
				this.getMaxY();
				
				this.updateBottomChartView();
			}
		},
	},
	data() {
		return {
			isUnfold: true,
			xWidth: 470,
			selectIndex: 0,
			lineWidth1: '0px',
			lineWidth2: '0px',
			lineWidth3: '0px',
			normalBpmLeft: null, // 日常表现
			normalBpmType: 0, // 0黄 1绿 2黄
			currentDeviateDescDate: null, // 当前偏离描述 圆点颜色
			currentDeviateDescColor: null, // 当前偏离描述 圆点颜色
			currentDeviateDesc: null, // 当前偏离描述
			currentNormalDescColor: null, // 当前日常描述 圆点颜色
			currentNormalDesc: null, // 当前日常描述
			deviateBpmFocusStr: ' ',
			currentRangeStr: ' ',
			currentScopeImageType: 0,
			currentTitleIsLineFeed: false,
			needMaxY: 0, // 上部分视图Y轴最大值

			chartWidth: 477,
			singWidth: 0
		};
	},
	created() {
		window.addEventListener('resize', () => {
			if (this.FirstChartMain) {
				this.FirstChartMain.resize();
			}
			if (this.secondChart) {
				this.secondChart.resize();
			}
		});
	},
	mounted() {
		// 卡片是否展开处理
		if (this.$props.isFold == true) {
			this.isUnfold = false;
		}

		if (this.$props.data) {

			// 求上部分视图的Y轴最大值
			this.getMaxY();

			// 副图表默认选中最后一根胶囊
			let item = JSON.parse(JSON.stringify(this.$props.data));
			if (item && item.data && item.data.length > 0) {
				this.selectIndex = item.data.length - 1;
			}

			// 主图表 + 副图表绘制
			this.updateBottomChartView();
		}
	},
	methods: {
		getMaxY() {
			if (this.$props.data) {

				// 求上部分视图的Y轴最大值
				let needMaxY = 0;
				let theData = JSON.parse(JSON.stringify(this.$props.data));
				let theDataList = theData.data || [];
				if (theDataList && theDataList.length > 0 ) {
					for (let i = 0; i < theDataList.length; i++) {
						let theDataListItem = theDataList[i];
						if (theDataListItem && theDataListItem.extendData) {
							let item_data_extendData = theDataListItem.extendData;
							let tempDeviateData = item_data_extendData.deviateData || [];
							let tempNormalData = item_data_extendData.normalData || [];
							for (let k = 0; k < tempDeviateData.length; k++) {
								let tempY = tempDeviateData[k];
								if (tempY && tempY > 0 && tempY > needMaxY) {
									needMaxY = tempY;
								}
							}
							for (let k = 0; k < tempNormalData.length; k++) {
								
								let tempY = tempNormalData[k];
								if (tempY && tempY > 0 && tempY > needMaxY) {
									needMaxY = tempY;
								}
							}
						}
					}
				}

				this.needMaxY = needMaxY;
			}
		},
		unflodClick() {
			this.isUnfold = !this.isUnfold;
		},
		updateBottomChartView() {
			// 1.初始化图表
			if (!this.FirstChartMain) {
				this.FirstChartMain = this.$echarts.init(document.getElementById(this.$props.echartId + 'FirstChartMain'), null, { renderer: 'svg' });
				let _this = this;
				this.FirstChartMain.on('click', function (params) {
					// if (params.componentType === 'series' && params.seriesType === 'bar') {
						var dataIndex = params.dataIndex;
						// alert('你点击了第' + dataIndex + '个柱子，其值为' + params.value);
						_this.selectIndex = dataIndex;
						_this.updateTopChartView()
						_this.updateBottomChartView();
					// }
				});
			}

			// 2.设置主图表 Option
			let item = JSON.parse(JSON.stringify(this.$props.data));
			let needDataMin = [];
			let needDataMedian = [];
			let needDataMax = [];
			let deviateFlags = [];
			let tempArr = JSON.parse(JSON.stringify(item.data || []));
			for (let i = 0; i < tempArr.length; i++) {
				let item = tempArr[i];
				if (item && item.extendData && item.extendData.deviateFlag == 3) {
					needDataMin.push(0);
					needDataMedian.push(parseInt(item.median));
					needDataMax.push(0);
				} else {
					needDataMin.push(item.min);
					needDataMedian.push(parseInt(item.median));
					needDataMax.push(item.max - item.min);
				}
				deviateFlags.push(item.extendData && item.extendData.deviateFlag ? item.extendData.deviateFlag : 2)
			}
			let xAxis_data = item.xaxis || [];
			let series_data = [
				{ data: needDataMin },
				{ data: needDataMax },
				{ data: needDataMedian },
			];
			let expansion_data = item.xaxisCn || [];
			let markArea_range = item.range || [];
			if (markArea_range.length != 2) {
				markArea_range = [];
			}

			// let option = getEchartsOptionFloatA3(xAxis_data); 
			// this.FirstChartMain.setOption(option, true);	

			let option = getEchartsOptionFloatA5(xAxis_data, series_data, expansion_data, markArea_range, this.$props.type == 0, deviateFlags, this.selectIndex);
			// let option = getEchartsOptionFloatA31(xAxis_data, series_data, expansion_data, markArea_range, this.$props.type == 0, deviateFlags, this.selectIndex);
			this.FirstChartMain.setOption(option, true);	


			// 3.更新副图表
			this.$forceUpdate()
			this.updateTopChartView();
		},
		updateTopChartView() {

			// 1.无图表时初始化图表
			if (!this.secondChart) {
				this.secondChart = this.$echarts.init(document.getElementById(this.$props.echartId + 'secondChart'), null, { renderer: 'svg' });
				this.$forceUpdate()
			}

			// 2.处理数据
			if (this.$props.data) {
				let item = JSON.parse(JSON.stringify(this.$props.data));
				if (item.data && item.data.length > 0 && item.data[this.selectIndex] && item.data[this.selectIndex].extendData) {
					let item_data = item.data[this.selectIndex];
					let item_data_extendData = item_data.extendData;
					
					let deviateFlag = item_data_extendData.deviateFlag; // 1红 2蓝 3灰色
					let normalFlag = item_data_extendData.normalFlag; // 1绿 2黄
					let deviateData = item_data_extendData.deviateData;
					let normalData = item_data_extendData.normalData;
					let deviateBpm = item_data_extendData.deviateBpm;
					let normalBpm = item_data_extendData.normalBpm;

					// 图表上放的黄绿黄线条
					if (item_data_extendData && item_data_extendData.naxis && item_data_extendData.naxis.length > 0 && item_data_extendData.naxis.length == 3) {
						let naxis = item_data_extendData.naxis;
						let minValue = naxis[0][0];
						let maxValue = naxis[2][1];
						let difference = maxValue - minValue;
						let scale1 = (naxis[0][1] - naxis[0][0]) / difference;
						let scale2 = (naxis[1][1] - naxis[1][0]) / difference;
						let scale3 = (naxis[2][1] - naxis[2][0]) / difference;
						if (!scale1) {
							scale1 = 0;
						}
						if (!scale2) {
							scale2 = 0;
						}
						if (!scale3) {
							scale3 = 0;
						}
						this.lineWidth1 = (630 * scale1 - 7) + 'px';
						this.lineWidth2 = (630 * scale2 + 14) + 'px';
						this.lineWidth3 = (630 * scale3 - 7)+ 'px';

						this.normalBpmLeft = (630 * ((normalBpm - minValue) / difference) - 7) + 'px';

						if (normalBpm < naxis[0][1]) {
							this.normalBpmType = 0;
						} else if (normalBpm > naxis[2][0]) {
							this.normalBpmType = 2;
						} else {
							this.normalBpmType = 1;
						}
					}

					// 偏离描述 ｜ 日常表现
					this.currentDeviateDescDate = item_data_extendData.date || '';
					this.currentDeviateDesc = item_data_extendData.deviateDesc || '';
					this.currentNormalDesc = item_data_extendData.normalDesc || '';
					if (deviateFlag == 1) {
						this.currentDeviateDescColor = 'rgba(255, 113, 134, 1)';
						this.currentScopeImageType = 1;
					} else if (deviateFlag == 2) {
						this.currentDeviateDescColor = 'rgba(74, 124, 232, 1)';
						this.currentScopeImageType = 2;
					} else if (deviateFlag == 3) {
						this.currentDeviateDescColor = 'rgba(165, 169, 188, 1)'
						this.currentScopeImageType = 3;
					}
					if (normalFlag == 1) {
						this.currentNormalDescColor = 'rgba(53, 192, 160, 1)'
					} else if (normalFlag == 2) {
						this.currentNormalDescColor = 'rgba(255, 206, 11, 1)';
					}

					// 多集中在 | 范围
					if (item_data_extendData && item_data_extendData.deviateBpmFocus) {
						this.deviateBpmFocusStr = item_data_extendData.deviateBpmFocus + '次/分左右';
					} else {
						this.deviateBpmFocusStr = ' ';
					}
					if (item_data_extendData.range && item_data_extendData.range.length == 2) {
						this.currentRangeStr = item_data_extendData.range[0] + '～' + item_data_extendData.range[1] + '次/分'
					} else {
						this.currentRangeStr = '';
					}


					// X 轴
					let xAxis_data = item_data_extendData.xaxis || [];

					this.singWidth = this.chartWidth / xAxis_data.length;

					/**
					 * line_datas 线条数据二维数组
					 * line_datas_colors 线条颜色数组
					 * line_datas_widths 线条宽度数组
					 * line_datas_shadows_colors 线条阴影数组
					 * scatter_datas 小圆点数据二维数组
					 * scatter_datas_colors 小圆点颜色数组
					 * markArea_ranges 区域面积二维数据
					 * markArea_ranges_colors 区域颜色数组
					 */
					// line_datas  | line_datas_colors | line_datas_widths | line_datas_shadows_colors | scatter_datas | scatter_datas_colors
					let line_datas = [];
					let line_datas_colors = [];
					let line_datas_widths = [];
					let line_datas_shadows_colors = [];
					let scatter_datas = [];
					let scatter_datas_colors = [];
					let markArea_ranges = [];
					let markArea_ranges_colors = [];
					// 偏离的
					if (deviateData && deviateData.length > 0) {
						line_datas.push(deviateData);
						scatter_datas.push([deviateBpm.toString(), deviateData[xAxis_data.indexOf(deviateBpm)]]);
						let left = (deviateBpm - 0.5 < 0 ? 0 : deviateBpm - 0.5).toString();
						let right = (deviateBpm + 0.5 > xAxis_data[xAxis_data.length - 1] ? Axis_data[xAxis_data.length - 1] : deviateBpm + 0.5).toString();
						markArea_ranges.push([left, right]);
						if (deviateFlag == 1) {
							line_datas_colors.push('rgba(255, 113, 134, 1)');
							line_datas_widths.push(1.5);
							line_datas_shadows_colors.push('rgba(255, 113, 134, 0.1)');
							scatter_datas_colors.push('rgba(255, 113, 134, 1)');
							markArea_ranges_colors.push('rgba(255, 113, 134, 0.1)');
						} else if (deviateFlag == 2) {
							line_datas_colors.push('rgba(74, 124, 232, 1)');
							line_datas_widths.push(1.5);
							line_datas_shadows_colors.push('rgba(74, 124, 232, 0.1)');
							scatter_datas_colors.push('rgba(74, 124, 232, 1)');
							markArea_ranges_colors.push('rgba(74, 124, 232, 0.1)');
						} else if (deviateFlag == 3) {
							line_datas_colors.push('rgba(165, 169, 188, 0.2)');
							line_datas_widths.push(5);
							line_datas_shadows_colors.push('green');
							scatter_datas_colors.push('rgba(53, 192, 160, 1)');
							markArea_ranges_colors.push('rgba(53, 192, 160, 0.1)');
						}
					}
					// 日常的
					if (normalData && normalData.length > 0) {
						line_datas.push(normalData);
						scatter_datas.push([normalBpm.toString(), normalData[xAxis_data.indexOf(normalBpm)]]);
						let left = (normalBpm - 0.5 < 0 ? 0 : normalBpm - 0.5).toString();
						let right = (normalBpm + 0.5 > xAxis_data[xAxis_data.length - 1] ? Axis_data[xAxis_data.length - 1] : normalBpm + 0.5).toString()
						markArea_ranges.push([left, right]);
						if (normalFlag == 1) {
							line_datas_colors.push('rgba(165, 169, 188, 0.2)');
							line_datas_widths.push(5);
							line_datas_shadows_colors.push(null);
							scatter_datas_colors.push('rgba(53, 192, 160, 1)');
							markArea_ranges_colors.push('rgba(53, 192, 160, 0.1)');
						} else if (normalFlag == 2) {
							line_datas_colors.push('rgba(165, 169, 188, 0.2)');
							line_datas_widths.push(5);
							line_datas_shadows_colors.push(null);
							scatter_datas_colors.push('rgba(255, 206, 11, 1)');
							markArea_ranges_colors.push('rgba(235, 188, 0, 0.1)');
						}
					}

					let option = getEchartsOptionLineE1(xAxis_data, line_datas, line_datas_colors, line_datas_widths, line_datas_shadows_colors, scatter_datas, scatter_datas_colors, markArea_ranges, markArea_ranges_colors, this.needMaxY);
					this.secondChart.setOption(option, true);

					if (item) {
						let tempStr1 = item_data_extendData.deviateDesc || '';
						let tempStr2 = tempStr2 ? item_data_extendData.date + '：' : item_data_extendData.date;
						let tempStr = tempStr1 + tempStr2;
						let tempWidth = this.getStringWidth(tempStr, 14, 'PingFangSC, PingFang SC')
						if (tempWidth > 490) {
							this.currentTitleIsLineFeed = true;
						} else {
							this.currentTitleIsLineFeed = false;
						}
					}
				}
			}
		},
		getStringWidth(text, fontSize, fontFamily) {
			const canvas = document.createElement('canvas');
			const context = canvas.getContext('2d');
			context.font = `${fontSize}px ${fontFamily}`;
			const metrics = context.measureText(text);
			return metrics.width;
		}
	},
};
</script>
<style lang="scss" scoped>
.miniCard ::v-deep {
	background: #ECF0F3;

	.unfoldImgTrue {
		background: url('../../../assets/icon_common_special_arrow_10.png') no-repeat no-repeat;
		background-size: contain;
	}

	.unfoldImgFalse {
		background: url('../../../assets/icon_common_special_arrow_9.png') no-repeat no-repeat;
		background-size: contain;
	}

	.richContentStyle {
		display: flex;
	}

	.richTextStyleNormal {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(31, 38, 53, 1);
		line-height: 25px;
	}

	.richTextStyleRed {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(255, 113, 134, 1);
		line-height: 25px;
	}
}

.miniCard:hover {
	background: rgba(223, 232, 252, 1) !important;

	.unfoldImgTrue {
		background: url('../../../assets/icon_common_special_arrow_12.png') no-repeat no-repeat;
		background-size: contain;
	}

	.unfoldImgFalse {
		background: url('../../../assets/icon_common_special_arrow_11.png') no-repeat no-repeat;
		background-size: contain;
	}
}

.miniCardTop {
	background: rgba(255, 255, 255, 0.85);
	border-radius: 12px;
	border: 1px solid #FFFFFF;
	display: flex;
	flex-direction: column;
	padding-top: 12px;
	padding-bottom: 15px;
	margin: 5px;
}

</style>